import type { MixpanelSource } from "#types/tracking.ts";
import { createContext, type PropsWithChildren, use } from "react";

interface Context {
    trackingAppIdentifier: string;
    trackingSource: MixpanelSource;
}

const Context = createContext<Context | null>(null);

export const TrackingProvider = ({ children, trackingAppIdentifier, trackingSource }: PropsWithChildren<Context>) => {
    return (
        <Context value={{ trackingAppIdentifier, trackingSource }}>
            {children}
        </Context>
    );
};

export const useTrackingContext = () => {
    const context = use(Context);

    if (!context) {
        throw new Error("useTrackingContext must be used within an TrackingProvider");
    }

    return context;
};
